import errors from './errors/index.js';
import translation from './translation/index.js';
const zhHK = Object.freeze({
    translation,
    errors,
});
export default zhHK;
